import type { Services } from "../data/services";
import type { FroshBotEngine } from "./types";
import { LiveFroshBot } from "./liveService";
import { MockFroshBot } from "./mockService";

/**
 * One engine per session, created lazily — the conversation must survive the
 * chat screen unmounting (Telegram's BackButton pops it), so the transcript
 * cannot live in component state.
 *
 * Live by default, mirroring the iOS `useLiveFroshBot`; `?froshbot=mock`
 * selects the ported mock for offline development.
 */
let engine: FroshBotEngine | null = null;

export function getFroshBot(services: Services): FroshBotEngine {
  if (!engine) {
    const wantMock =
      typeof window !== "undefined" &&
      new URLSearchParams(window.location.search).get("froshbot") === "mock";
    engine = wantMock ? new MockFroshBot() : new LiveFroshBot(services);
  }
  return engine;
}

/* ------------------------------------------------------------------ */
/* Onboarding payoff                                                   */
/* ------------------------------------------------------------------ */

/**
 * The payoff moment (O9): onboarding ends in live chat, and FroshBot's first
 * message visibly uses what was just entered. Onboarding arms a hidden kickoff
 * turn here before pushing the chat screen; the screen fires it on mount. The
 * payoff flag also renders the DM-portability chip row — the one line that
 * makes the relationship legible as portable.
 */
let pendingKickoff: string | null = null;
let payoffMode = false;

export function armPayoffKickoff(kickoff: string): void {
  pendingKickoff = kickoff;
  payoffMode = true;
}

export function takeKickoff(): string | null {
  const kickoff = pendingKickoff;
  pendingKickoff = null;
  return kickoff;
}

export function inPayoffMode(): boolean {
  return payoffMode;
}
